



















import { MetaInfo } from 'vue-meta';
import { Component, Vue } from 'vue-property-decorator';
import Profile from  '@/components/my-account/Profile.vue';

@Component({
  metaInfo(this: Auth):MetaInfo {
    return {
      title: this.getPageTitle(),
      meta: [
        { name: 'description', content: this.getPageDescription() }
      ]
    }
  },
  components: {
    Profile
  },
})
export default class Auth extends Vue {
    getPageTitle() {
      return `${this.$data.title} | Pacific Standard`;
    }

    getPageDescription() {
      return this.$data.description;
    }

    data() {
        return {
          title: 'Mi cuenta',
          description: 'Actualiza tu información de contacto.',
        };
    }
}
